<template>
<w-sliding-popup class="device-info-popup" ref="slidingPopup" :title="title" width="1100px">
  <div slot="content" style="height: 100%">
    <div v-if="!isShowProcessList" style="height: 100%">
      <el-form :model="formData" ref="form" label-width="130px" label-position="top">
        <el-row>
          <el-col :span="10" style="padding: 0px 5px;">
            <div class="mr-b25">
              <h4 class="title-bar">장비중요도</h4>
              <el-row>
                <el-form-item label="중요도">
                  <el-input-number style="width: 50%;" v-model="formData.importanceValue" controls-position="right" :min="1" :max="maxImportanceValue"></el-input-number>
                </el-form-item>
              </el-row>
            </div>
            <!-- 장비 상태 범례 안보여줌 -->
            <!-- <div class="mr-b25">
              <h4 class="title-bar">장비 상태</h4>
              <el-row>
                <el-form-item label="등록 상태">
                  <el-radio-group v-model="formData.statusCode">
                    <el-radio label="N">신규</el-radio>
                    <el-radio label="M">위치 변경</el-radio>
                    <el-radio label="TR">폐기 진행</el-radio>
                    <el-radio label="TF">폐기</el-radio>
                    <el-radio label="C">취소</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="만료일자">
                  <el-date-picker v-model="formData.finishDatetime" type="date" placeholder="만료일자" format="yyyy-MM-dd" />
                </el-form-item>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="적용시간">
                    <span>{{ formData.registDatetime || '-' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="등록자">
                    <span>{{ formData.managerId || '-' }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </div> -->
            <div class="mr-b25" v-if="isShowActiveStandby">
              <h4 class="title-bar">Active / Standby</h4>
              <el-row>
                <el-form-item label="표시 여부">
                  <el-radio-group v-model="formData.activeShow">
                    <el-radio label="Y">표시</el-radio>
                    <el-radio label="N">숨김</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="상태 설정">
                  <el-radio-group :disabled="isDisableActiveGet" v-model="formData.activeGet">
                    <el-radio label="A">자동</el-radio>
                    <el-radio label="M">수동</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-row>
              <el-row v-show="formData.activeGet === 'A'">
                <el-row v-show="currentView === 'process'">
                  <el-form-item label="프로세스">
                    <el-row v-show="isShowDbmsWarning">
                      <span>※ DB 서버에 Server Agent가 설치되어 있어야 설정 가능합니다.</span>
                    </el-row>
                    <el-input style="width: calc(100% - 38px);" :disabled="true" v-model="formData.processName"></el-input>
                    <el-button :disabled="isDisableActiveStandby" @click="clickShowProcessListBtn">
                      <i class="fas fa-cog"></i>
                    </el-button>
                    <el-row :class="isDisableActiveStandby ? $style['table-wrapper-disabled'] : ''" style="margin-top: 2px;">
                      <el-table :data="formData.processTableData" class="popup" height="100%" style="width: 100%;">
                        <el-table-column label="상태" prop="status" align="center"></el-table-column>
                        <el-table-column label="값" prop="value" align="center"></el-table-column>
                      </el-table>
                    </el-row>
                  </el-form-item>
                </el-row>
                <el-row v-show="currentView === 'oid'">
                  <el-form-item label="OID">
                    <el-input style="width: 100%;" :disabled="isDisableActiveStandby" v-model="formData.oidName"></el-input>
                    <el-row :class="isDisableActiveStandby ? $style['table-wrapper-disabled'] : ''" style="margin-top: 2px; display: block;">
                      <el-table :data="formData.oidTableData" class="popup" height="100%" style="width: 100%">
                        <el-table-column label="상태" prop="status" align="center">
                        </el-table-column>
                        <el-table-column label="값" prop="value" align="center">
                          <template slot-scope="child">
                            <el-input v-model="child.row.value">
                            </el-input>
                            <!-- <div class="component-div">
                              <div style="cursor: pointer; width:100%; display: flex; justify-content: center;" @dblclick.stop="doubleClickCell(child.row)">
                                <div :style="`display: ${child.row.textStatus}; padding-left: 10px;`" >{{ child.row.value }}</div>
                                <el-input v-model="child.row.value" @keyup.enter.native="doubleClickCell(child.row)" :style="`display: ${child.row.inputStatus}; padding-left: 15px;`">
                                </el-input>
                              </div>
                            </div> -->
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-row>
                  </el-form-item>
                </el-row>
              </el-row>
              <el-row v-show="formData.activeGet === 'M'">
                <el-form-item  label="상태">
                  <el-radio-group :disabled="isDisableActiveStandby" v-model="formData.status">
                    <el-radio label="A">Active</el-radio>
                    <el-radio label="S">Standby</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-row>
            </div>
          </el-col>
          <el-col :span="14" style="padding: 0px 5px;">
            <div class="mr-b25">
              <h4 class="title-bar">메모</h4>
              <el-form-item label="내용">
                <el-input type="textarea" v-model="formData.statusComment" resize="none" :rows="30"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-if="isShowProcessList" style="height: 100%">
      <div style="height: 100%">
        <div class="back-title title-bar">
          <i class="el-icon-back c-pointer mr-r4" @click="clickBackButton" style="cursor:pointer"></i> 프로세스 리스트
        </div>
        <div>
          <el-input size="mini" class="mr-t10 mr-b10" v-model="keyword" placeholder="검색 키워드를 입력해주십시오." @keyup.enter.native="searchFilter">
            <i class="el-input__icon el-icon-search" slot="suffix" style="cursor: pointer" @click="searchFilter"></i>
          </el-input>
        </div>
        <el-row style="height: calc(100% - 82px)">
          <el-table
            :data="processListData"
            highlight-current-row
            @row-click="clickProcessTableRow"
            height="100%"
            style="width: 100%"
            class="popup"
          >
            <el-table-column
              v-for="column in processListColumns"
              :show-overflow-tooltip="true"
              :key="column.prop"
              :prop="column.prop"
              :sortable="column.sortable"
              :label="column.label"
              :width="column.width"
              :align="column.align"
            >
            </el-table-column>
          </el-table>
        </el-row>
      </div>
    </div>
  </div>
  <div slot="footer">
    <el-button size="large" type="solid" @click="onSaveClick" :disabled="loading">저장</el-button>
    <el-button size="large" @click="close" :disabled="loading">취소</el-button>
  </div>
</w-sliding-popup>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';
import concat from 'lodash/concat';


import MapAPI from '@/api/topologymap/common';
import RscSettingsAPI from '@/api/settings/common/rsc-settings';
// import MapConst from '@/constants/topologymap';

import { Q, MapInfo } from '@/views/topologymap/js/maps';
import { isEmpty } from '@/utils/basic';
import { getDateToString } from '@/utils/date';
// import DateLanguages from '../utils/DateLanguages';
import serverTableInfoAPI from '@/api/performance/server/info-table';
import axios from 'axios';

export default {
  name: 'WDeviceInfoPopup',
  components: {},
  data() {
    return {
      formData: {},
      formDataDefault: {
        importanceValue: undefined,
        statusCode: 'C',
        statusComment: undefined,
        finishDatetime: undefined,
        registDatetime: undefined,
        managerId: undefined,
        activeShow: 'N',
        activeGet: 'A',
        status: 'S',
        processName: undefined,
        oidName: undefined,
        processTableData: [
          { status: 'Active', value: 'UP' },
          { status: 'Standby', value: 'DOWN' },
        ],
        oidTableData: [
          { status: 'Active', value: '67', inputStatus: 'none', textStatus: '' },
          { status: 'Standby', value: '67', inputStatus: 'none', textStatus: '' },
        ],
      },
      currentView: '',
      selectedObjectModel: undefined,
      loadedData: undefined,
      isShowProcessList: false,
      processListData: [],
      originProcessListData: [],
      processListColumns: [
        { prop: 'procPid', label: 'PID', align: 'left', sortable: true, width: 122 },
        { prop: 'procName', label: '프로세스 명', sortable: true, align: 'left' },
      ],
      loading: false,
      maxImportanceValue: undefined,
      keyword: '',
    };
  },
  computed: {
    title() {
      return `장비 표현 정보${this.selectedObjectModel ? `[${this.selectedObjectModel.get('objName')}]` : ''}`;
    },
    objId() {
      return this.getModelData('objId');
    },
    objManagetypeId() {
      return this.getModelData('objManagetypeId');
    },
    parentObjId() {
      return this.getModelData('parentObjId');
    },
    objDefineId() {
      return this.getModelData('objDefineId');
    },
    isShowActiveStandby() {
      const objManagetypeId = this.objManagetypeId;
      const objDefineId = this.objDefineId;
      let result = false;
      if ((objManagetypeId === 'NMS' && objDefineId === 'NETDEVICE') || objManagetypeId === 'SMS' || objManagetypeId === 'DBMS') {
        result = true;
      }
      return result;
    },
    isShowDbmsWarning() {
      return (this.objManagetypeId === 'DBMS' && isEmpty(this.parentObjId));
    },
    isDisableActiveGet() {
      return (this.formData && this.formData.activeShow === 'N');
    },
    isDisableActiveStandby() {
      return (this.formData && this.formData.activeShow === 'N') || (this.isShowDbmsWarning);
    },
  },
  methods: {
    /**
     * 팝업 오픈 요청
     * @author KangBonghun(toto1323)
     * @param  {[type]} params [description]
     */
    open(params) {
      this.selectedObjectModel = params.selectedObjectModel;
      this.isShowProcessList = false;
      this.$refs.slidingPopup.open();

      this.setCurrentView();
      this.initForm();
      this.loadData();
    },
    /**
     * 팝업 닫기 요청
     * @author KangBonghun(toto1323)
     */
    close() {
      if (this.isShowProcessList) {
        this.clickBackButton();
      } else {
        this.$refs.slidingPopup.close();
      }
    },
    setCurrentView() {
      let currentView = '';
      const { objManagetypeId } = this;
      if (objManagetypeId) {
        if (objManagetypeId === 'SMS' || objManagetypeId === 'DBMS') {
          currentView = 'process';
        } else if (objManagetypeId === 'NMS') {
          currentView = 'oid';
        }
      }
      this.currentView = currentView;
    },
    initForm() {
      this.formData = cloneDeep(this.formDataDefault);
      // this.formData = Object.assign({}, this.formDataDefault);
    },
    loadData() {
      axios.all([
        MapAPI.getObjectInfo(this.objId),
        RscSettingsAPI.getObjImportanceLevelList(),
      ]).then(axios.spread((objectInfoRes, objImportanceLevelList) => {
        this.maxImportanceValue = (objImportanceLevelList && objImportanceLevelList.length) || 5;
        this.loadedData = Object.assign({}, (objectInfoRes.data && objectInfoRes.data.success && objectInfoRes.data.data));
        this.setForm();
      })).catch((e) => {
        Q.log(e);
      });
    },
    setForm() {
      if (this.loadedData) {
        this.setFormImportance();
        this.setFormObjManageStatus();
        this.setFormActive();
      }
    },
    setFormImportance() {
      if (this.loadedData.importance && this.loadedData.importance.value) {
        this.formData.importanceValue = this.loadedData.importance.value;
      }
    },
    setFormObjManageStatus() {
      const { formData, loadedData } = this;

      if (loadedData.objManageStatus) {
        formData.statusCode = loadedData.objManageStatus.statusCode || 'C';
        formData.statusComment = loadedData.objManageStatus.statusComment || '';
        formData.finishDatetime = loadedData.objManageStatus.finishDatetime;
        if (loadedData.objManageStatus.registDatetime) {
          formData.registDatetime = getDateToString(loadedData.objManageStatus.registDatetime, 'YYYY-MM-DD');
        } else {
          formData.registDatetime = '-';
        }
        formData.managerId = loadedData.objManageStatus.managerId || '-';
      }
    },
    setFormActive() {
      const { formData, loadedData } = this;
      if (loadedData.active && Object.keys(loadedData.active).length > 0) {
        const loadedActive = loadedData.active;
        formData.activeShow = (loadedActive.activeGet !== 'H') ? 'Y' : 'N';
        formData.activeGet = loadedActive.activeGet || 'A';
        formData.status = loadedActive.status || 'S';
        if (this.currentView === 'process') {
          if (!isEmpty(loadedActive.checkValue) && loadedActive.checkValue !== 'null') {
            formData.processName = loadedActive.checkValue;
          }
        } else if (this.currentView === 'oid') {
          if (!isEmpty(loadedActive.checkValue) && loadedActive.checkValue !== 'null') {
            formData.oidName = loadedActive.checkValue;
          }
          const oidTableData = this.parseOidTableData(loadedActive);
          formData.oidTableData = [
            { status: 'Active', value: oidTableData.activeValue, inputStatus: 'none', textStatus: '' },
            { status: 'Standby', value: oidTableData.standbyValue, inputStatus: 'none', textStatus: '' },
          ];
        }
      }
    },
    parseOidTableData(paramData) {
      const result = {
        activeValue: '67',
        standbyValue: '67',
      };
      const FIRSTVALUE = 0;
      if (!isEmpty(paramData.activeValue) && paramData.activeValue !== 'null') {
        if (paramData.activeValue.includes(',')) {
          result.activeValue = paramData.activeValue.split(',')[FIRSTVALUE];
        } else {
          result.activeValue = paramData.activeValue;
        }
      }
      if (!isEmpty(paramData.standbyValue) && paramData.standbyValue !== 'null') {
        if (paramData.standbyValue.includes(',')) {
          result.standbyValue = paramData.standbyValue.split(',')[FIRSTVALUE];
        } else {
          result.standbyValue = paramData.standbyValue;
        }
      }
      return result;
    },
    getModelData(key) {
      return this.selectedObjectModel && this.selectedObjectModel.get(key);
    },
    onSaveClick() {
      if (this.isShowProcessList) {
        this.clickBackButton();
      } else {
        const params = this.makeParam();
        if (params) {
          this.loading = true;
          MapAPI.updateObjectInfo(params).then((response) => {
            if (response.data.success) {
              this.$message.success('장비정보를 저장하였습니다.');
              const canvas = MapInfo.getInstance(this).getCanvas();
              canvas.refreshObjResult();
              this.close();
              // MapAPI.getObjLegendByObj(this.objId).then((response2) => {
              //   const legendObject = response2.data.data;
              //   this.selectedObjectModel.updateLegend(legendObject);
              // });
            }
          }).catch((e) => {
            this.$message.error('장비정보를 저장하지 못하였습니다.');
            Q.log(e);
          }).finally(() => {
            this.loading = false;
          });
        }
      }
    },
    makeParam() {
      try {
        const obj = { objId: this.objId };
        const importance = this.makeParamImportance();
        const objManageStatus = this.makeParamObjManageStatus();
        const active = this.makeParamActive();

        return {
          obj,
          importance,
          objManageStatus,
          active,
        };
      } catch (e) {
        this.$message.error(e.message);
        return null;
      }
    },
    makeParamImportance() {
      return {
        value: this.formData.importanceValue || null,
      };
    },
    makeParamObjManageStatus() {
      const { formData } = this;
      const returnObj = {
        statusCode: formData.statusCode ? formData.statusCode : 'C',
        registDatetime: formData.registDateTime ? new Date(formData.registDatetime).getTime() : new Date().getTime(),
        finishDatetime: formData.finishDatetime ? new Date(formData.finishDatetime).getTime() : null,
        statusComment: formData.statusComment ? formData.statusComment : '',
        // TODO: 사용자 ID를 전달 받아야 한다.
        managerId: 'administrator',
      };
      return returnObj;
    },
    makeParamActive() {
      const { formData } = this;
      const returnObj = {};
      if (this.currentView === 'process' && isEmpty(formData.processName) && !this.isDisableActiveStandby && formData.activeGet === 'A') {
        throw new Error('프로세스를 선택해주십시오.');
      } else {
        returnObj.activeGet = (formData.activeShow === 'N') ? 'H' : formData.activeGet;
        returnObj.activeShow = formData.activeShow;
        returnObj.status = formData.status;
        if (this.currentView === 'process') {
          returnObj.checkValue = formData.processName;
          returnObj.nodeType = 'SV';
        } else if (this.currentView === 'oid') {
          const ACTIVE = 0;
          const STANDBY = 1;
          returnObj.activeValue = formData.oidTableData[ACTIVE].value;
          returnObj.standbyValue = formData.oidTableData[STANDBY].value;
          returnObj.checkValue = formData.oidName;
          returnObj.nodeType = 'NW';
        }
      }
      return returnObj;
    },
    doubleClickCell(rowData) {
      if (rowData.inputStatus === '') {
        rowData.inputStatus = 'none';
        rowData.textStatus = '';
      } else {
        rowData.inputStatus = '';
        rowData.textStatus = 'none';
      }
    },
    clickShowProcessListBtn() {
      this.getProcessList();
      this.isShowProcessList = true;
    },
    getProcessList() {
      const params = {
        objId: this.objId,
        conditionId: 'procTotalCount',
      };
      serverTableInfoAPI.getCurrentProcessInfoList(params).then((response) => {
        if (response.data.success) {
          this.processListData = this.concatSmsProcessListData(response.data.data);
          this.originProcessListData = cloneDeep(this.processListData);
        }
      });
    },
    concatSmsProcessListData(data) {
      let listData = [];
      if (!isEmpty(data)) {
        forEach(data.major, (item) => {
          item.majorFlag = true;
        });
        listData = concat(data.major, data.process);
      }
      return listData;
    },
    clickBackButton() {
      this.isShowProcessList = false;
    },
    clickProcessTableRow(row) {
      this.formData.processName = row.procName;
    },
    searchFilter() {
      if (this.keyword === '') {
        this.processListData = cloneDeep(this.originProcessListData);
        return;
      }
      this.isLoading = true;
      const condition = this.keyword.toLowerCase();
      const filterData = [];
      this.originProcessListData.forEach((item) => {
        const pid = item.procPid.toString();
        const pname = item.procName.toString().toLowerCase();
        if (pid.match(condition)) {
          filterData.push(item);
        }
        if (pname.match(condition)) {
          filterData.push(item);
        }
      });
      this.processListData = filterData;
    },
  },
};
</script>
<style lang="scss">
.device-info-popup {
  .body-content {
    height: calc(100% - 25px);
    padding: 25px 25px 25px 25px !important;
  }
  .el-scrollbar__view {
    height: 100%;
  }
  .el-input-number.el-input-number--mini.is-controls-right .el-icon-arrow-up:before{
    content: "\f0d8";
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
  }
  .el-input-number.el-input-number--mini.is-controls-right .el-icon-arrow-down:before{
    content: "\f0d7";
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
  }
}
</style>
<style module>
.table-wrapper-disabled {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  opacity: 0.4;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/popup/DeviceInfoPopup.vue